import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./verticals.css";

const Verticals = () => {
  const [, setActiveVertical] = useState(null);
  const [selectedVertical, setSelectedVertical] = useState(null);
  const [activeTab, setActiveTab] = useState("overview");
  const navigate = useNavigate();

  const verticals = [
    {
      id: 1,
      name: "Health",
      tagline: "Wellness Revolution",
      heroSubtitle: "Building a Healthier Generation, One Life at a Time",
      description: "Building a healthier generation through preventive care, mental wellness, and holistic development programs.",
      fullAbout: "Health is the foundation upon which every aspiration, achievement, and dream is built. A healthy student is more confident, productive, innovative, and capable of contributing meaningfully to society. The Health Vertical of Yi YUVA is dedicated to creating awareness, encouraging healthy lifestyles, promoting preventive healthcare, and inspiring young individuals to become ambassadors of well-being within their campuses and communities.\n\nToday's world presents numerous health challenges: sedentary lifestyles, increasing stress, unhealthy eating habits, lack of physical activity, mental health concerns, substance abuse, lifestyle diseases, and inadequate awareness about preventive healthcare. The Health Vertical exists to address these challenges by creating a culture where health is viewed not merely as the absence of disease but as a state of complete physical, mental, emotional, and social well-being.",
      vision: "To cultivate a generation of healthy, compassionate, and socially responsible youth who prioritize physical fitness, mental well-being, preventive healthcare, and holistic wellness while inspiring healthier communities across India.",
      mission: "The Health Vertical is committed to empowering students with knowledge, resources, and opportunities that encourage healthier lifestyles and informed health decisions. Through collaborative programs, expert guidance, community outreach, and innovative awareness campaigns, we strive to make health education accessible, engaging, and impactful for every student.",
      whyItMatters: "Health influences every aspect of human life. Academic performance, creativity, emotional intelligence, leadership capabilities, productivity, and personal relationships are all closely connected to physical and mental well-being. Students often face demanding schedules, examination pressure, social expectations, digital distractions, irregular sleep patterns, and nutritional challenges. By investing in student wellness today, we contribute to building stronger families, healthier workplaces, and more resilient communities tomorrow.",
      icon: "/images/health.png",
      color: "from-cyan-400 to-cyan-600",
      accent: "#06b6d4",
      layout: "featured",
      row: 1,
      col: 1,
      size: "large",
      stats: [
        { label: "Active Members", value: "250+" },
        { label: "Health Camps", value: "15+" },
        { label: "Impacted Students", value: "1,200+" }
      ],
      objectives: [
        "Promote holistic physical, mental, emotional, and social well-being.",
        "Create awareness about preventive healthcare and healthy lifestyles.",
        "Encourage regular physical activity and fitness routines.",
        "Foster mental health awareness and emotional resilience.",
        "Organize medical camps and health screening initiatives.",
        "Promote nutritional awareness and healthy dietary practices.",
        "Encourage voluntary blood donation and organ donation awareness.",
        "Collaborate with healthcare professionals, hospitals, and wellness orgs."
      ],
      pillars: [
        { title: "Preventive Healthcare", desc: "Emphasizes regular health check-ups, vaccinations, hygiene, early detection of illnesses, and informed lifestyle choices." },
        { title: "Physical Fitness", desc: "Daily exercise, walking and cycling initiatives, campus fitness challenges, yoga sessions, and marathon participation." },
        { title: "Mental Health & Well-being", desc: "Reduces stigma through stress management workshops, mindfulness, emotional resilience training, and peer support." },
        { title: "Nutrition & Healthy Living", desc: "Balanced diets, hydration awareness, reading nutrition labels, and avoiding excessive processed food consumption." },
        { title: "Community Health", desc: "Serving society through free medical camps, rural health awareness, sanitation drives, and public hygiene campaigns." }
      ],
      focusAreas: [
        "Mental wellness", "Physical fitness", "Lifestyle diseases", "Diabetes awareness", "Heart health", "Women's health", "Men's health", "Nutrition", "Eye care", "Dental hygiene", "Sleep health", "Substance abuse prevention", "Tobacco-free initiatives", "CPR & First Aid", "Blood donation", "Organ donation awareness", "Digital wellness"
      ],
      initiatives: [
        { name: "Blood Donation Drives", desc: "Organizing campus-wide voluntary blood donation drives in partnership with certified blood banks." },
        { name: "Mega Health & Screening Camps", desc: "Comprehensive health check-ups including eye tests, dental screening, and blood pressure analysis." },
        { name: "Lifesaver CPR Workshop", desc: "Hands-on emergency response and CPR certification for students and faculty." },
        { name: "MindMatters Summit", desc: "Annual conference featuring psychologists, mindfulness experts, and peer support circles." },
        { name: "FitYUVA Marathon & Rallies", desc: "High-energy fitness runs and cycling rallies promoting active daily movement." }
      ],
      collaborations: [
        "Hospitals & Medical Colleges", "Public Health Organizations", "NGOs & Non-Profits", "Fitness Centers & Coaches", "Mental Health Professionals", "Healthcare Startups & Tech"
      ],
      leadershipAndImpact: "Students gain hands-on experience in event planning, community engagement, volunteer management, crisis response coordination, and social impact measurement while developing compassionate leadership qualities.",
      futureOutlook: "Exploring AI-enabled health awareness, digital wellness tracking platforms, preventive screening campaigns, and telehealth education for rural communities.",
      benefits: [
        "Certified First Aid and CPR emergency training",
        "Exclusive access to sports and wellness facilities",
        "Mentorship from healthcare professionals & certified coaches",
        "Certified volunteer hours for community medical camps"
      ]
    },
    {
      id: 2,
      name: "Entrepreneurship",
      tagline: "Founder's Ecosystem",
      heroSubtitle: "Empowering Visionaries to Build the Future",
      description: "Empowering student entrepreneurs with mentorship, funding access, and real-world business experience.",
      fullAbout: "Entrepreneurship is more than starting a business—it is a mindset of innovation, resilience, problem-solving, and value creation. The Entrepreneurship Vertical of Yi YUVA is committed to nurturing the next generation of entrepreneurs, innovators, changemakers, and business leaders who will create sustainable solutions, generate employment, and contribute to national economic growth.\n\nIn an era driven by digital transformation and global connectivity, entrepreneurship has emerged as a powerful catalyst for progress. The Entrepreneurship Vertical provides students with the ecosystem, resources, and exposure needed to cultivate entrepreneurial thinking, validate ideas, develop business models, and transform innovative concepts into successful ventures.",
      vision: "To cultivate an entrepreneurial ecosystem that empowers students to become innovative leaders, ethical entrepreneurs, and impactful changemakers capable of building sustainable businesses and driving national development.",
      mission: "The Entrepreneurship Vertical is dedicated to fostering entrepreneurial thinking through education, mentorship, industry engagement, innovation, and practical learning experiences. We strive to equip students with the confidence, skills, and opportunities required to identify problems, develop innovative solutions, create scalable ventures, and contribute to society.",
      whyItMatters: "Entrepreneurship is a driving force behind economic growth, technological innovation, and social transformation. For students, entrepreneurial thinking develops critical skills such as creativity, leadership, strategic thinking, adaptability, financial literacy, communication, and decision-making. These competencies are valuable in every profession.",
      icon: "/images/enterprenurship.png",
      color: "from-orange-400 to-orange-600",
      accent: "#f97316",
      layout: "standard",
      row: 1,
      col: 2,
      size: "medium",
      stats: [
        { label: "Startups Incubated", value: "18+" },
        { label: "Mentors Network", value: "40+" },
        { label: "Pitch Grants", value: "₹5L+" }
      ],
      objectives: [
        "Inspire entrepreneurial thinking and creative problem solving.",
        "Support startup ideation and business model validation.",
        "Connect student founders with mentors, investors, and industry experts.",
        "Encourage research-driven innovation and commercialization.",
        "Foster ethical, sustainable, and socially responsible entrepreneurship.",
        "Develop leadership, financial management, and pitch skills.",
        "Facilitate networking with incubation centers and seed funds.",
        "Promote women entrepreneurship and inclusive business building."
      ],
      pillars: [
        { title: "Innovation & Ideation", desc: "Observing real-world problems, prototyping solutions, and validating concepts through market research." },
        { title: "Leadership & Vision", desc: "Developing team building, decision-making under uncertainty, strategic negotiation, and pitching skills." },
        { title: "Problem Solving", desc: "Identifying high-impact challenges across healthcare, edtech, green tech, AI, and financial inclusion." },
        { title: "Collaboration", desc: "Interdisciplinary teamwork combining engineering, management, design, law, and healthcare." },
        { title: "Ethical Business", desc: "Transparent business practices, social responsibility, and sustainable long-term value creation." }
      ],
      focusAreas: [
        "Startup ideation", "Lean Startup methodology", "Business model canvas", "Design thinking", "FinTech", "HealthTech", "EdTech", "AgriTech", "Green entrepreneurship", "Social enterprise", "Deep tech & AI", "Patents & IPR", "Angel funding", "Venture capital", "Financial planning", "Brand strategy"
      ],
      initiatives: [
        "YUVA Pitchfest: Annual pitch competition connecting student startups with angel investors.",
        "Founder's Circle: Fireside chats and intimate Q&A sessions with successful young founders.",
        "Startup Sprint Bootcamp: Weekend intensive sprint on customer discovery, MVP building, and marketing.",
        "HackYUVA Innovation Expo: Showcasing working prototypes to industry mentors and incubators."
      ],
      collaborations: [
        "Startup Incubators & Technology Parks", "Angel Investor Networks & VC Funds", "Government Innovation Bodies", "Alumni Entrepreneur Associations", "Corporate Innovation Accelerators"
      ],
      leadershipAndImpact: "Students master strategic decision-making, market research, team management, investor negotiation, public speaking, and financial literacy while launching real businesses.",
      futureOutlook: "Preparing founders for AI-driven business models, green tech ventures, web3 applications, and global market expansion.",
      benefits: [
        "Direct access to angel investors and seed accelerator programs",
        "1-on-1 mentorship from industry founders and venture capitalists",
        "Co-founder matching and legal incorporation guidance",
        "Free credits for cloud infrastructure, analytics, and dev tools"
      ]
    },
    {
      id: 3,
      name: "Innovation",
      tagline: "Future Builders",
      heroSubtitle: "Transforming Ideas into Impact",
      description: "Pioneering breakthrough solutions through design thinking, prototyping, and disruptive innovation.",
      fullAbout: "Innovation is the driving force behind every significant advancement in society. It is the ability to challenge conventional thinking, identify opportunities, and develop creative solutions that improve lives and shape the future. The Innovation Vertical of Yi YUVA is dedicated to cultivating a culture where curiosity inspires discovery, creativity leads to meaningful action, and every student is empowered to become an innovator.\n\nFrom Artificial Intelligence and Robotics to Sustainable Development and Smart Cities, every breakthrough begins with a simple question: 'How can we do this better?' The Innovation Vertical serves as a platform where students from diverse academic disciplines come together to think differently, collaborate effectively, and create solutions for real-world problems.",
      vision: "To inspire and empower a generation of creative thinkers, innovators, and problem-solvers who leverage knowledge, technology, and collaboration to create sustainable solutions that positively impact society, industry, and the nation.",
      mission: "The Innovation Vertical is committed to fostering an environment where creativity, research, design thinking, and technological advancement converge to solve real-world challenges. Through experiential learning, interdisciplinary collaboration, mentorship, and industry engagement, we equip students to transform ideas into impactful solutions.",
      whyItMatters: "Today's world faces unprecedented challenges including climate change, healthcare accessibility, cybersecurity, digital transformation, sustainable development, and urbanization. Addressing these challenges requires innovative thinking that combines creativity with scientific knowledge, technology, and human-centered design.",
      icon: "/images/innovation.png",
      color: "from-blue-400 to-blue-600",
      accent: "#3b82f6",
      layout: "standard",
      row: 1,
      col: 3,
      size: "medium",
      stats: [
        { label: "Hackathons Conducted", value: "12+" },
        { label: "Prototypes Built", value: "60+" },
        { label: "Patents Filed", value: "4" }
      ],
      objectives: [
        "Foster creative thinking, design mindset, and analytical problem-solving.",
        "Promote research-driven innovation and technology experimentation.",
        "Encourage interdisciplinary collaboration across engineering, science, & management.",
        "Support prototype development, maker labs, and patent filings.",
        "Connect student innovators with R&D labs and industry leaders.",
        "Promote sustainable, green, and socially responsible technologies.",
        "Facilitate participation in national and international hackathons."
      ],
      pillars: [
        { title: "Design Thinking", desc: "Empathizing with users, defining core challenges, ideating, building rapid prototypes, and iterative testing." },
        { title: "Research & Development", desc: "Scientific inquiry, technology exploration, evidence-based validation, and product experimentation." },
        { title: "Tech & Digital Shift", desc: "Exploring AI, Robotics, IoT, Blockchain, Cybersecurity, Cloud, AR/VR, and Quantum computing." },
        { title: "Interdisciplinary Work", desc: "Combining insights from engineering, medicine, management, design, and humanities." },
        { title: "Sustainable Design", desc: "Creating solutions for renewable energy, circular economy, waste reduction, and accessibility." }
      ],
      focusAreas: [
        "Artificial Intelligence", "Machine Learning", "Robotics & Automation", "Internet of Things", "Smart Cities", "HealthTech", "AgriTech", "Climate Technology", "Biotechnology", "Human-Centered Design", "Patent Development", "Industry 4.0", "Open Source Software"
      ],
      initiatives: [
        { name: "HackYUVA 24-Hour Hackathon", desc: "Inter-collegiate coding and hardware hackathon solving urban civic problems." },
        { name: "Build-In-Public Sprint", desc: "4-week sprint where student teams build and ship software/hardware in public." },
        { name: "AI & Emerging Tech Lab", desc: "Hands-on workshops exploring LLMs, AI agents, edge computing, and IoT sensors." },
        { name: "Patent Awareness Drive", desc: "Guidance on filing patents, intellectual property rights, and technology licensing." }
      ],
      collaborations: [
        "Technology Corporations & R&D Labs", "Research Universities & Institutes", "Government Innovation Missions", "Maker Spaces & Fabrication Labs", "International Research Networks"
      ],
      leadershipAndImpact: "Students gain mastery in project management, technical evaluation, rapid prototyping, patent strategy, and cross-functional team leadership.",
      futureOutlook: "Preparing students for Industry 4.0, autonomous systems, generative AI applications, quantum computing, and space technology innovations.",
      benefits: [
        "Access to advanced hardware kits, 3D printing, and IoT lab facilities",
        "Mentorship from senior software architects & principal researchers",
        "Sponsorship and grants for national and international hackathons",
        "Direct portfolio showcase to premier global technology firms"
      ]
    },
    {
      id: 4,
      name: "Accessibility",
      tagline: "Inclusive Future",
      heroSubtitle: "Creating an Inclusive Future Where Everyone Belongs",
      description: "Creating an inclusive ecosystem where diversity is celebrated and every voice is heard.",
      fullAbout: "Accessibility is the foundation of an inclusive and equitable society. It is the commitment to ensuring that every individual, regardless of physical ability, sensory capability, cognitive condition, age, gender, or socioeconomic background, has equal opportunities to learn, participate, contribute, and succeed. The Accessibility Vertical of Yi YUVA is dedicated to fostering a culture where inclusion is not viewed as an accommodation but as a fundamental human right.\n\nIn today's world, true progress is measured by our ability to create environments accessible to everyone. Educational institutions, workplaces, digital platforms, and community programs must be designed with inclusivity at their core. The Accessibility Vertical works to eliminate barriers, promote universal design, encourage empathy, and empower every individual to participate fully with dignity and independence.",
      vision: "To create an inclusive society where accessibility, equality, and universal participation empower every individual to reach their full potential without barriers or discrimination.",
      mission: "The Accessibility Vertical is committed to promoting inclusive environments through advocacy, universal design, assistive technology, digital accessibility, and awareness campaigns. We equip students to create physical, digital, and social spaces where diversity is celebrated and every voice is heard.",
      whyItMatters: "Inclusion strengthens innovation, enriches learning, and builds compassionate communities. By encouraging students to understand diverse perspectives and design solutions that serve everyone, we prepare future leaders capable of building a more equitable world.",
      icon: "/images/accessibility.png",
      color: "from-emerald-400 to-emerald-600",
      accent: "#10b981",
      layout: "standard",
      row: 2,
      col: 1,
      size: "medium",
      stats: [
        { label: "Campus Audits", value: "20+" },
        { label: "Sign Language Learners", value: "300+" },
        { label: "Assistive Projects", value: "10+" }
      ],
      objectives: [
        "Promote digital accessibility compliance (WCAG) across web & mobile platforms.",
        "Conduct campus accessibility audits for ramps, elevators, and tactile paths.",
        "Organize Indian Sign Language (ISL) learning bootcamps and deaf culture awareness.",
        "Develop affordable assistive technology hardware and mobility aids.",
        "Advocate for neurodiversity, learning difference awareness, and mental inclusion.",
        "Partner with disability rights NGOs, special schools, and rehab centers."
      ],
      pillars: [
        { title: "Digital Inclusion", desc: "Ensuring websites, mobile apps, and learning management systems are screen-reader accessible." },
        { title: "Sign Language & Culture", desc: "Teaching Indian Sign Language (ISL) and building bridges between deaf and hearing communities." },
        { title: "Physical Accessibility", desc: "Auditing educational infrastructure for wheelchair ramps, braille signage, and tactile paving." },
        { title: "Neurodiversity Support", desc: "Creating supportive learning spaces for students with dyslexia, ADHD, and autism spectrum conditions." }
      ],
      focusAreas: [
        "Universal Design", "WCAG 2.1 Web Accessibility", "Indian Sign Language", "Assistive Robotics", "Braille literacy", "Neurodiversity", "Equal Opportunity Advocacy", "Campus Mobility Audits"
      ],
      initiatives: [
        { name: "Sign & Connect ISL Bootcamp", desc: "Interactive Indian Sign Language learning workshops for students and faculty." },
        { name: "A11y Tech Hackathon", desc: "Building open-source screen reader tools, voice navigation, and low-cost wheelchair add-ons." },
        { name: "Inclusive Campus Audit Drive", desc: "Evaluating campus buildings for wheelchair accessibility and publishing actionable reports." }
      ],
      collaborations: [
        "Disability Advocacy NGOs", "Special Education Institutes", "Assistive Tech Startups", "Government Social Justice Departments", "National Institutes for Speech & Hearing"
      ],
      leadershipAndImpact: "Students learn universal design principles, empathy-driven product architecture, accessibility testing methods, and inclusive policy advocacy.",
      futureOutlook: "Fostering AI-driven speech-to-sign translation, smart wearable mobility aids, and automated digital accessibility compliance checkers.",
      benefits: [
        "Certified training in Web Accessibility Guidelines (WCAG)",
        "Indian Sign Language (ISL) basic & intermediate certificates",
        "Hands-on experience developing real-world assistive devices",
        "Recognition from national inclusion advocacy groups"
      ]
    },
    {
      id: 5,
      name: "Sports",
      tagline: "Champion Spirit",
      heroSubtitle: "Inspiring Excellence Through Sports, Leadership, and Teamwork",
      description: "Developing athlete leaders through sports excellence, mental resilience, and teamwork.",
      fullAbout: "Sport is far more than competition—it is a powerful platform for developing leadership, discipline, resilience, teamwork, and character. The Sports Vertical of Yi YUVA is dedicated to fostering a vibrant sporting culture that empowers students to lead healthier, more active, and purpose-driven lives while promoting excellence both on and off the field.\n\nIn today's fast-paced world, students find themselves balancing academic commitments and career goals. Physical well-being and sporting engagement are critical in shaping confident, resilient, and emotionally balanced individuals. The Sports Vertical believes sports cultivate lifelong values such as integrity, perseverance, mutual respect, strategic thinking, and leadership for every student regardless of skill level.",
      vision: "To build a generation of physically fit, mentally resilient, disciplined, and socially responsible youth who embrace sports as a way of life and inspire healthier, more active communities.",
      mission: "The Sports Vertical is committed to promoting sportsmanship, physical fitness, inclusivity, and leadership among students by creating opportunities for participation, competition, learning, and community engagement. We strive to establish sports as a catalyst for personal growth, teamwork, and holistic development.",
      whyItMatters: "Sports play a vital role in shaping individuals beyond physical fitness. They strengthen mental resilience, improve concentration, enhance decision-making abilities, and build confidence. Students who actively engage in sports develop stronger interpersonal skills, stress management, academic focus, and leadership capabilities.",
      icon: "/images/sports.png",
      color: "from-pink-400 to-pink-600",
      accent: "#ec4899",
      layout: "featured",
      row: 2,
      col: 2,
      size: "large",
      stats: [
        { label: "Tournaments Held", value: "25+" },
        { label: "Student Athletes", value: "800+" },
        { label: "Trophies Won", value: "34" }
      ],
      objectives: [
        "Promote physical fitness, endurance, and active daily habits.",
        "Organize inter-college and intra-college sports leagues.",
        "Foster sportsmanship, fair play, and ethical competition.",
        "Nurture student athletic talent for state & national levels.",
        "Conduct sports psychology and mental conditioning sessions.",
        "Promote gender-inclusive and adaptive sports participation.",
        "Develop event management and sports administration skills."
      ],
      pillars: [
        { title: "Physical Fitness", desc: "Daily routines, running clubs, strength & conditioning, yoga, and adventure activities." },
        { title: "Sportsmanship", desc: "Respect for opponents, fair play, humility in victory, and grace in defeat." },
        { title: "Leadership in Sports", desc: "Captaining teams, tournament logistics, strategic planning, and volunteer coordination." },
        { title: "Teamwork & Synergy", desc: "Building trust, communication, shared responsibility, and mutual respect among teammates." },
        { title: "Mental Toughness", desc: "Managing pressure, emotional control, resilience, and positive self-belief." }
      ],
      focusAreas: [
        "Cricket", "Football", "Volleyball", "Basketball", "Badminton", "Table Tennis", "Athletics", "Chess", "Kabaddi", "Tennis", "Swimming", "Marathon & Endurance", "E-sports", "Sports analytics", "Sports psychology", "Injury prevention"
      ],
      initiatives: [
        { name: "YUVA Champions League", desc: "Annual inter-collegiate sports festival featuring multiple athletic disciplines." },
        { name: "Night Sports Carnival", desc: "High-energy evening sports matches, fests, and fitness challenges." },
        { name: "Athlete Leadership Academy", desc: "Workshops translating sports field principles to corporate boardrooms and leadership." },
        { name: "Community Sports Drive", desc: "Organizing sports and fitness coaching for underprivileged school children." }
      ],
      collaborations: [
        "Professional Sports Academies", "National Sports Federations", "Certified Athletic Coaches", "Physiotherapists & Nutritionists", "Sports Tech & Wearable Startups"
      ],
      leadershipAndImpact: "Students gain expertise in tournament administration, crowd management, sports marketing, sponsorship acquisition, and crisis control under pressure.",
      futureOutlook: "Integrating wearable performance sensors, AI video analytics for athlete coaching, e-sports analytics, and sustainable eco-friendly sporting events.",
      benefits: [
        "Professional athletic coaching and physical conditioning support",
        "Sponsorship for inter-college and state-level sports competitions",
        "Leadership roles managing large-scale tournaments and leagues",
        "Merit certificates and sports gear rewards for top achievers"
      ]
    },
    {
      id: 6,
      name: "Masoom",
      tagline: "Social Impact",
      heroSubtitle: "Protecting Childhood, Empowering Communities",
      description: "Driving meaningful social change through community-led initiatives and grassroots impact.",
      fullAbout: "Project Masoom is YUVA's core social impact arm focused on child protection, safety awareness, underprivileged education, and grassroots community upliftment. We conduct workshops on child rights, personal safety education, and book/toy donation drives across schools and communities.\n\nEvery child deserves a safe, nurturing environment to grow, learn, and dream. Project Masoom works tirelessly to educate children, parents, and educators about child rights, personal safety, and protection against abuse while empowering youth to become active protectors of community welfare.",
      vision: "To build a safe, protective, and empowering society where every child is educated, protected, nurtured, and given equal opportunity to thrive without fear or exploitation.",
      mission: "Project Masoom is committed to child protection awareness, holistic child development, and community welfare through school workshops, volunteer tutoring, awareness drives, and collaborative social projects.",
      whyItMatters: "Protecting children and uplifting vulnerable communities is the highest form of social responsibility. Engaging college students in grassroots advocacy builds empathy, civic awareness, and leadership rooted in compassion.",
      icon: "/images/masoom.png",
      color: "from-purple-400 to-purple-600",
      accent: "#a855f7",
      layout: "standard",
      row: 2,
      col: 3,
      size: "medium",
      stats: [
        { label: "Children Impacted", value: "5,000+" },
        { label: "School Sessions", value: "45+" },
        { label: "Active Volunteers", value: "350+" }
      ],
      objectives: [
        "Conduct age-appropriate personal safety education (Safe Touch / Unsafe Touch) in schools.",
        "Provide weekend educational tutoring and STEM exposure for underprivileged children.",
        "Organize stationery, book, clothing, and toy donation drives in shelter homes.",
        "Raise public awareness against child labor, child marriage, and child abuse.",
        "Train student volunteers in child psychology and compassionate mentorship."
      ],
      pillars: [
        { title: "Child Protection & Safety", desc: "Interactive personal safety sessions teaching children to recognize and report unsafe behavior." },
        { title: "Educational Upliftment", desc: "Peer tutoring in foundational literacy, math, science, and digital literacy for shelter home youth." },
        { title: "Joy of Giving", desc: "Collection drives for books, sports gear, clothing, and educational kits." },
        { title: "Child Rights Advocacy", desc: "Campaigns and street theater raising public awareness for child welfare laws and helplines." }
      ],
      focusAreas: [
        "Child Safety Education", "Safe Touch Awareness", "Underprivileged Tutoring", "Child Helpline 1098 Advocacy", "Donation Drives", "Digital Literacy for Kids", "Community Health & Hygiene"
      ],
      initiatives: [
        { name: "Project Suraksha Workshops", desc: "Personal safety and self-defense awareness sessions conducted in government & private schools." },
        { name: "Shiksha Volunteer Corps", desc: "Weekend tutoring and mentoring program at local orphanages and shelter homes." },
        { name: "Joy of Giving Festival", desc: "Annual collection and distribution of over 2,000 books, toys, and winter garments." }
      ],
      collaborations: [
        "Childline India & National Child Rights Bodies", "Non-Governmental Organizations (NGOs)", "Primary & Secondary Schools", "Social Welfare Departments"
      ],
      leadershipAndImpact: "Students develop profound empathy, public speaking, community mobilization, volunteer management, and social initiative leadership skills.",
      futureOutlook: "Expanding interactive digital safety animation kits, child helpline integration, and mobile learning labs for rural schools.",
      benefits: [
        "Certified social service and volunteer hours documentation",
        "Deep personal fulfillment through grassroots community impact",
        "Leadership roles heading city-wide volunteer campaigns",
        "Networking with social entrepreneurs, child psychologists, and NGOs"
      ]
    },
    {
      id: 7,
      name: "Road Safety",
      tagline: "Life Matters",
      heroSubtitle: "Saving Lives Through Awareness, Discipline, and Action",
      description: "Creating awareness and fostering responsible behavior to build safer communities.",
      fullAbout: "The Road Safety Vertical aims to drastically reduce traffic mishaps and promote responsible road usage among youth. Through high-impact street plays, traffic awareness rallies, helmet enforcement drives, and first-responder training, we save lives and transform commuter culture.\n\nRoad traffic accidents are one of the leading causes of preventable youth fatalities globally. By instilling strict adherence to traffic discipline, mandatory helmet/seatbelt usage, and Good Samaritan emergency response training, YUVA volunteers work on the front lines to make roads safer for everyone.",
      vision: "To achieve zero preventable road fatalities by cultivating a culture of responsible driving, strict traffic discipline, and immediate emergency response among youth and citizens across India.",
      mission: "The Road Safety Vertical is dedicated to educating commuters, training Good Samaritan first-responders, conducting awareness rallies, and collaborating with traffic authorities to build safer road ecosystems.",
      whyItMatters: "Every life saved on the road preserves a family's future. By transforming student commuters into safety champions, we build a law-abiding, compassionate civic society.",
      icon: "https://res.cloudinary.com/dtpl599ko/image/upload/v1777434200/roadsafety_lb3rd8.png",
      color: "from-red-400 to-red-600",
      accent: "#ef4444",
      layout: "standard",
      row: 3,
      col: 1,
      size: "medium",
      stats: [
        { label: "Rallies & Drives", value: "30+" },
        { label: "Commuters Reached", value: "20,000+" },
        { label: "Helmets Distributed", value: "500+" }
      ],
      objectives: [
        "Promote 100% helmet and seatbelt compliance among student two-wheeler and four-wheeler drivers.",
        "Train students as Golden Hour First Responders for road accident emergency triage.",
        "Conduct street plays (Nukkad Natak) at major city traffic junctions and bus terminals.",
        "Collaborate with Traffic Police for traffic management during peak hours.",
        "Educate commuters on Good Samaritan Law rights and anti-drunk driving rules."
      ],
      pillars: [
        { title: "Protective Gear Enforcement", desc: "Promoting mandatory certified helmet and seatbelt usage through awareness drives." },
        { title: "Traffic Rule Discipline", desc: "Educating drivers on lane discipline, signal compliance, and pedestrian right-of-way." },
        { title: "Golden Hour First Response", desc: "Training commuters in immediate trauma care, CPR, and safe victim evacuation." },
        { title: "Creative Street Advocacy", desc: "Using street theater, flash mobs, and poster campaigns to influence driver behavior." }
      ],
      focusAreas: [
        "Helmet Campaigns", "Good Samaritan Law", "First-Responder CPR", "Anti-Drunk Driving", "Pedestrian Safety", "Speed Limit Awareness", "Traffic Police Collaboration", "Civic Discipline"
      ],
      initiatives: [
        { name: "Safe Commute Bike Rally", desc: "Youth motorcycle rally promoting helmet safety and zero phone usage while driving." },
        { name: "Golden Hour Trauma Workshop", desc: "Certified training on emergency first aid, bleeding control, and accident site safety." },
        { name: "Smart Signals Volunteer Drive", desc: "Assisting traffic police officers during peak hours at major city intersections." }
      ],
      collaborations: [
        "City Traffic Police Departments", "Emergency Medical Services & Trauma Care", "Automobile Associations", "Road Safety NGOs"
      ],
      leadershipAndImpact: "Students build crisis management, public advocacy, event coordination, legal compliance, and community outreach leadership skills.",
      futureOutlook: "Deploying AI traffic safety monitoring, student hazard mapping apps, and smart helmet awareness campaigns.",
      benefits: [
        "Certified First Responder and Emergency Trauma Training",
        "Direct commendation certificates from Traffic Police authorities",
        "Creative expression through street drama, video, and design",
        "Civic leadership awards for outstanding community service"
      ]
    },
    {
      id: 8,
      name: "Learning",
      tagline: "Knowledge Empowers",
      heroSubtitle: "Unlocking Human Potential Through Lifelong Learning",
      description: "Unlocking potential through adaptive learning experiences and skill development programs.",
      fullAbout: "The Learning Vertical empowers students with high-demand industry skills, career readiness, and lifelong learning habits. From software engineering and data science to public speaking and financial literacy, we organize peer-led study groups, industry bootcamps, and masterclasses.\n\nIn a world where technology and job markets evolve rapidly, continuous learning is the ultimate competitive advantage. The Learning Vertical bridges the gap between academic curricula and industry expectations by providing practical, project-based skill building.",
      vision: "To cultivate a community of continuous learners, skilled professionals, and peer mentors equipped to excel in the global knowledge economy.",
      mission: "The Learning Vertical is committed to democratizing practical skill development, career readiness, financial literacy, and peer mentorship for every student regardless of background.",
      whyItMatters: "Knowledge transforms lives. Equipping youth with real-world technical, analytical, and interpersonal skills ensures higher employability, career confidence, and financial independence.",
      icon: "/images/learning.png",
      color: "from-indigo-400 to-indigo-600",
      accent: "#6366f1",
      layout: "standard",
      row: 3,
      col: 2,
      size: "medium",
      stats: [
        { label: "Skill Workshops", value: "40+" },
        { label: "Certifications Earned", value: "450+" },
        { label: "Peer Tutors", value: "60+" }
      ],
      objectives: [
        "Deliver weekend bootcamps in full-stack development, Python, Data Science, & AI.",
        "Provide 1-on-1 resume building, LinkedIn optimization, and mock interview coaching.",
        "Demystify personal finance, budgeting, stock market investing, and taxation for youth.",
        "Facilitate peer-to-peer study circles, book clubs, and skill swapping sessions.",
        "Partner with industry practitioners for guest masterclasses and certification tracks."
      ],
      pillars: [
        { title: "Tech & Practical Skills", desc: "Hands-on coding, cloud computing, data analysis, and software development tracks." },
        { title: "Career & Corporate Readiness", desc: "Resume clinics, behavioral interview prep, public speaking, and professional communication." },
        { title: "Financial Literacy", desc: "Budgeting, investing basics, personal tax management, and wealth creation concepts." },
        { title: "Peer Learning Circles", desc: "Collaborative study groups, mentorship pairs, and open learning repositories." }
      ],
      focusAreas: [
        "Full-Stack Web Dev", "Python & Data Science", "Resume Building", "Public Speaking", "Financial Literacy", "Personal Finance", "UI/UX Design", "Mock Interviews", "Peer Tutoring"
      ],
      initiatives: [
        { name: "YUVA Skill Academy", desc: "Weekend masterclass series taught by senior software engineers and corporate leaders." },
        { name: "Resume & Interview Clinic", desc: "1-on-1 resume reviews and mock technical/HR interviews with industry mentors." },
        { name: "FinLit Youth Series", desc: "Interactive bootcamps on personal budgeting, stock markets, and smart investing." }
      ],
      collaborations: [
        "Corporate Training Partners", "EdTech Platforms", "Industry Professional Networks", "Alumni Mentors Association"
      ],
      leadershipAndImpact: "Students build instructional design, public speaking, peer coaching, curriculum development, and organization skills.",
      futureOutlook: "AI-driven personalized learning paths, micro-credentialing badges, and global peer mentorship exchanges.",
      benefits: [
        "Free enrollment in verified technical & business masterclasses",
        "1-on-1 career resume reviews and mock interview sessions",
        "Access to curated learning roadmaps & study repositories",
        "Paid stipends and certificates for peer tutoring leaders"
      ]
    },
    {
      id: 9,
      name: "Climate Change",
      tagline: "Sustainable Future",
      heroSubtitle: "Empowering Young Leaders to Build a Climate-Resilient Tomorrow",
      description: "Driving climate action through sustainability, innovation, environmental stewardship, and community engagement.",
      fullAbout: "Climate change is one of the greatest challenges facing humanity, impacting ecosystems, economies, public health, and future generations. Rising global temperatures, extreme weather events, biodiversity loss, and resource depletion demand urgent collective action. The Climate Change Vertical of Yi YUVA empowers students to become sustainability leaders by promoting environmental awareness, climate innovation, and responsible living.\n\nThis vertical inspires young changemakers to design sustainable solutions, adopt environmentally responsible practices, and contribute toward achieving the United Nations Sustainable Development Goals (SDGs). Through education, research, policy discussions, clean technology, and community-driven initiatives, we aim to create a generation capable of leading the transition toward a greener, more resilient future.",
      vision: "To build a climate-resilient society where innovation, sustainability, and environmental responsibility empower every individual to protect the planet for future generations.",
      mission: "The Climate Change Vertical is committed to promoting climate awareness, sustainable innovation, renewable energy adoption, biodiversity conservation, waste management, and carbon reduction initiatives. We equip students with the knowledge, skills, and leadership required to create measurable environmental impact.",
      whyItMatters: "Climate action is no longer optional—it is essential for humanity's survival. Every sustainable decision made today contributes to healthier communities, cleaner ecosystems, and a resilient future. By empowering students with climate literacy and green innovation skills, we prepare responsible leaders capable of solving tomorrow's environmental challenges.",
      icon: "/images/climate.png",
      color: "from-green-500 to-emerald-700",
      accent: "#16a34a",
      layout: "standard",
      row: 2,
      col: 2,
      size: "medium",
      stats: [
        { label: "Trees Planted", value: "5,000+" },
        { label: "Students Engaged", value: "2,500+" },
        { label: "Climate Projects", value: "50+" }
      ],
      objectives: [
        "Promote climate literacy and sustainability awareness across educational institutions.",
        "Encourage renewable energy adoption and clean technology innovation.",
        "Organize tree plantation drives, biodiversity restoration, and ecosystem conservation programs.",
        "Promote waste segregation, recycling, composting, and circular economy practices.",
        "Support carbon footprint reduction through green campus initiatives.",
        "Collaborate with environmental organizations, researchers, industries, and government agencies."
      ],
      pillars: [
        {
          title: "Climate Education",
          desc: "Building awareness on climate science, sustainability, carbon emissions, and environmental responsibility."
        },
        {
          title: "Green Innovation",
          desc: "Encouraging sustainable technologies including renewable energy, smart agriculture, and climate-tech startups."
        },
        {
          title: "Conservation & Biodiversity",
          desc: "Protecting forests, water bodies, wildlife, and ecosystems through restoration and conservation initiatives."
        },
        {
          title: "Sustainable Communities",
          desc: "Promoting eco-friendly lifestyles, zero-waste campuses, and responsible resource management."
        }
      ],
      focusAreas: [
        "Climate Action",
        "Renewable Energy",
        "Carbon Neutrality",
        "Green Buildings",
        "Circular Economy",
        "Waste Management",
        "Biodiversity Conservation",
        "Water Conservation",
        "Sustainable Agriculture",
        "Climate Technology"
      ],
      initiatives: [
        {
          name: "Green Campus Mission",
          desc: "Transforming campuses through waste segregation, renewable energy adoption, and carbon footprint assessments."
        },
        {
          name: "Climate Innovation Challenge",
          desc: "Hackathons focused on developing sustainable technologies for energy, agriculture, water, and waste management."
        },
        {
          name: "Mission One Million Trees",
          desc: "Large-scale tree plantation and ecosystem restoration campaigns involving students and local communities."
        }
      ],
      collaborations: [
        "Ministry of Environment, Forest and Climate Change",
        "Environmental NGOs",
        "UN Sustainable Development Goals Network",
        "Renewable Energy Companies",
        "Climate-Tech Startups",
        "Research Institutions",
        "Municipal Corporations"
      ],
      leadershipAndImpact: "Students develop expertise in sustainability leadership, climate policy, environmental research, renewable technologies, carbon accounting, and community engagement while leading impactful environmental initiatives.",
      futureOutlook: "Driving innovation in AI-powered climate monitoring, smart energy systems, carbon capture technologies, green mobility, sustainable cities, and climate-resilient infrastructure to accelerate India's transition toward a net-zero future.",
      benefits: [
        "Professional certification in Sustainability & Climate Leadership",
        "Hands-on experience in renewable energy and climate innovation projects",
        "Participation in national and international environmental campaigns",
        "Industry networking with climate-tech startups and sustainability experts",
        "Leadership opportunities in green campus initiatives",
        "Recognition through environmental awards and impact programs"
      ]
    }
  ];

  // Lock body scroll when modal is active
  useEffect(() => {
    if (selectedVertical) {
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
      document.documentElement.style.overflow = "unset";
    };
  }, [selectedVertical]);

  // Handle ESC key to close modal
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setSelectedVertical(null);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleOpenModal = (vertical) => {
    setSelectedVertical(vertical);
    setActiveTab("overview");
  };

  const handleJoinClick = () => {
    setSelectedVertical(null);
    navigate("/membership");
  };

  const featuredVerticals = verticals.filter(v => v.layout === "featured");
  const standardVerticals = verticals.filter(v => v.layout === "standard");

  return (
    <>
      <Navbar />

      <div className="verticals-page-premium">
        {/* CINEMATIC HERO SECTION */}
        <section className="premium-verticals-hero">
          <div className="hero-background" />

          <div className="hero-content">
            <h1 className="hero-title">
              <span className="title-line">Choose Your</span>
              <span className="title-line gradient-text">Impact Zone</span>
            </h1>

            <p className="hero-subtitle">
              YUVA Verticals are built to transform ambitious students into leaders, innovators, athletes, entrepreneurs, and changemakers. Click on any vertical to explore details and find your path.
            </p>

            <div className="hero-accent-line" />
          </div>
        </section>

        {/* FEATURED VERTICALS - ASYMMETRICAL SHOWCASE */}
        <section className="featured-section">
          <div className="featured-container">
            {featuredVerticals.map((vertical, idx) => (
              <div
                key={vertical.id}
                className="featured-vertical"
                style={{
                  animationDelay: `${idx * 0.15}s`
                }}
                onMouseEnter={() => setActiveVertical(vertical.id)}
                onMouseLeave={() => setActiveVertical(null)}
                onClick={() => handleOpenModal(vertical)}
              >
                <div className={`featured-card bg-gradient-to-br ${vertical.color}`}>
                  <div className="featured-glow" />

                  <div className="featured-content">
                    <div className="featured-icon">
                      <img src={vertical.icon} alt={vertical.name} />
                    </div>

                    <h2 className="featured-title">{vertical.name}</h2>
                    <p className="featured-tagline">{vertical.tagline}</p>

                    <p className="featured-description">
                      {vertical.description}
                    </p>

                    <button
                      className="featured-cta-button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOpenModal(vertical);
                      }}
                    >
                      <span>Explore Vertical</span>
                      <span className="arrow">→</span>
                    </button>
                  </div>

                  <div className="featured-particles">
                    <div className="particle particle-1" />
                    <div className="particle particle-2" />
                    <div className="particle particle-3" />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* STANDARD VERTICALS - PREMIUM GRID */}
        <section className="verticals-masonry-section">
          <div className="section-intro">
            <h2 className="section-title">More Paths to Impact</h2>
            <p className="section-subtitle">Click any vertical card to view initiatives, pillars, and opportunities</p>
            <div className="intro-line" />
          </div>

          <div className="verticals-masonry">
            {standardVerticals.map((vertical, idx) => (
              <div
                key={vertical.id}
                className="masonry-item"
                style={{
                  animationDelay: `${idx * 0.08}s`
                }}
                onMouseEnter={() => setActiveVertical(vertical.id)}
                onMouseLeave={() => setActiveVertical(null)}
                onClick={() => handleOpenModal(vertical)}
              >
                <div className={`masonry-card bg-gradient-to-br ${vertical.color}`}>
                  <div className="card-overlay" />

                  <div className="card-content">
                    <div className="card-header-row">
                      <div className="card-icon">
                        <img src={vertical.icon} alt={vertical.name} />
                      </div>
                      <span className="badge-explore">Explore</span>
                    </div>

                    <h3 className="card-title">{vertical.name}</h3>
                    <p className="card-tagline">{vertical.tagline}</p>
                    <p className="card-description">{vertical.description}</p>

                    <div className="card-action-bar">
                      <span>View Details</span>
                      <span className="action-arrow">→</span>
                    </div>
                  </div>

                  <div className="card-glow" />
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* JOURNEY SECTION */}
        <section className="journey-section">
          <div className="journey-container">
            <div className="journey-left">
              <h2 className="section-eyebrow">Your Path</h2>
              <h3 className="journey-title">
                Start Your Journey Today
              </h3>

              <p className="journey-body">
                Each vertical represents a unique pathway to develop specific skills, gain real-world exposure, and make meaningful impact alongside like-minded ambitious peers.
              </p>

              <div className="journey-highlights">
                <div className="highlight-item">
                  <div className="highlight-icon">🚀</div>
                  <div className="highlight-text">
                    <h4>Real-World Exposure</h4>
                    <p>Industry mentorship and live projects</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">👥</div>
                  <div className="highlight-text">
                    <h4>Peer Network</h4>
                    <p>Connect with 100+ ambitious students</p>
                  </div>
                </div>
                <div className="highlight-item">
                  <div className="highlight-icon">🏆</div>
                  <div className="highlight-text">
                    <h4>Leadership Growth</h4>
                    <p>Structured development programs</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="journey-right">
              <div className="journey-visual">
                <div className="visual-blob blob-1" />
                <div className="visual-blob blob-2" />
                <div className="visual-blob blob-3" />
              </div>
            </div>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="verticals-cta">
          <div className="cta-container">
            <h2 className="cta-title">
              Find Your Tribe
            </h2>
            <p className="cta-subtitle">
              Every vertical is an opportunity to lead, innovate, and create impact
            </p>
            <button className="cta-button" onClick={() => navigate("/membership")}>
              Join a Vertical
              <span className="button-arrow">→</span>
            </button>
          </div>
        </section>
      </div>

      {/* RICH INTERACTIVE VERTICAL DETAIL MODAL */}
      {selectedVertical && (
        <div className="vert-modal-backdrop" onClick={() => setSelectedVertical(null)}>
          <div className="vert-modal-container" onClick={(e) => e.stopPropagation()}>

            {/* MODAL HEADER */}
            <div className="vert-modal-banner" style={{ borderColor: selectedVertical.accent }}>
              <div className="vert-modal-glow" style={{ background: `radial-gradient(circle, ${selectedVertical.accent}33 0%, transparent 70%)` }} />

              <button
                className="vert-modal-close"
                onClick={() => setSelectedVertical(null)}
                aria-label="Close modal"
              >
                ✕
              </button>

              <div className="vert-modal-hero-row">
                <div className="vert-modal-icon-box" style={{ borderColor: selectedVertical.accent }}>
                  <img src={selectedVertical.icon} alt={selectedVertical.name} />
                </div>

                <div className="vert-modal-title-col">
                  <span className="vert-modal-pill-tag" style={{ color: selectedVertical.accent }}>{selectedVertical.tagline}</span>
                  <h2 className="vert-modal-main-title">{selectedVertical.name} Vertical</h2>
                  {selectedVertical.heroSubtitle && (
                    <span className="vert-modal-sub-text">{selectedVertical.heroSubtitle}</span>
                  )}
                </div>
              </div>

              {/* QUICK STATS BAR */}
              <div className="vert-modal-stats-grid">
                {selectedVertical.stats.map((stat, idx) => (
                  <div key={idx} className="vert-modal-stat-card">
                    <span className="vert-modal-stat-num" style={{ color: selectedVertical.accent }}>{stat.value}</span>
                    <span className="vert-modal-stat-lbl">{stat.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* MODAL NAVIGATION TABS */}
            <div className="modal-tabs">
              <button
                className={`tab-btn ${activeTab === "overview" ? "active" : ""}`}
                onClick={() => setActiveTab("overview")}
                style={{
                  borderBottomColor: activeTab === "overview" ? selectedVertical.accent : "transparent",
                  color: activeTab === "overview" ? "#ffffff" : undefined
                }}
              >
                Overview & Vision
              </button>
              <button
                className={`tab-btn ${activeTab === "pillars" ? "active" : ""}`}
                onClick={() => setActiveTab("pillars")}
                style={{
                  borderBottomColor: activeTab === "pillars" ? selectedVertical.accent : "transparent",
                  color: activeTab === "pillars" ? "#ffffff" : undefined
                }}
              >
                Objectives & Pillars
              </button>
              <button
                className={`tab-btn ${activeTab === "initiatives" ? "active" : ""}`}
                onClick={() => setActiveTab("initiatives")}
                style={{
                  borderBottomColor: activeTab === "initiatives" ? selectedVertical.accent : "transparent",
                  color: activeTab === "initiatives" ? "#ffffff" : undefined
                }}
              >
                Activities & Focus
              </button>
              <button
                className={`tab-btn ${activeTab === "benefits" ? "active" : ""}`}
                onClick={() => setActiveTab("benefits")}
                style={{
                  borderBottomColor: activeTab === "benefits" ? selectedVertical.accent : "transparent",
                  color: activeTab === "benefits" ? "#ffffff" : undefined
                }}
              >
                Impact & Benefits
              </button>
            </div>

            {/* MODAL BODY CONTENT */}
            <div className="modal-body-content">
              {activeTab === "overview" && (
                <div className="tab-pane fade-in">
                  <h3 className="section-subheading">About {selectedVertical.name}</h3>
                  <div className="modal-full-about-formatted">
                    {selectedVertical.fullAbout.split("\n\n").map((para, i) => (
                      <p key={i} className="about-paragraph">{para}</p>
                    ))}
                  </div>

                  <div className="vision-mission-container">
                    <div className="vision-box" style={{ borderLeftColor: selectedVertical.accent }}>
                      <div className="vm-header">
                        <span className="vm-icon">🌟</span>
                        <h4>Our Vision</h4>
                      </div>
                      <p>{selectedVertical.vision}</p>
                    </div>

                    <div className="mission-box" style={{ borderLeftColor: selectedVertical.accent }}>
                      <div className="vm-header">
                        <span className="vm-icon">🎯</span>
                        <h4>Our Mission</h4>
                      </div>
                      <p>{selectedVertical.mission}</p>
                    </div>
                  </div>

                  {selectedVertical.whyItMatters && (
                    <div className="why-matters-box">
                      <h4 className="why-matters-title">Why {selectedVertical.name} Matters</h4>
                      <p>{selectedVertical.whyItMatters}</p>
                    </div>
                  )}
                </div>
              )}

              {activeTab === "pillars" && (
                <div className="tab-pane fade-in">
                  {selectedVertical.objectives && (
                    <div className="objectives-section">
                      <h3 className="section-subheading">Core Objectives</h3>
                      <ul className="objectives-list">
                        {selectedVertical.objectives.map((obj, idx) => (
                          <li key={idx} className="objective-item">
                            <span className="obj-bullet" style={{ color: selectedVertical.accent }}>▪</span>
                            <span>{obj}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  <h3 className="section-subheading" style={{ marginTop: "28px" }}>Pillars of {selectedVertical.name}</h3>
                  <div className="pillars-grid">
                    {selectedVertical.pillars.map((pillar, idx) => (
                      <div key={idx} className="pillar-card">
                        <div className="pillar-header">
                          {pillar.icon && <span className="pillar-icon">{pillar.icon}</span>}
                          <h4 className="pillar-title">{pillar.title}</h4>
                        </div>
                        <p className="pillar-desc">{pillar.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {activeTab === "initiatives" && (
                <div className="tab-pane fade-in">
                  {selectedVertical.focusAreas && (
                    <div className="focus-areas-container">
                      <h3 className="section-subheading">Key Focus Areas</h3>
                      <div className="focus-tags-cloud">
                        {selectedVertical.focusAreas.map((tag, idx) => (
                          <span key={idx} className="focus-tag" style={{ borderColor: `${selectedVertical.accent}55` }}>
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}

                  <h3 className="section-subheading" style={{ marginTop: "28px" }}>Signature Programs & Activities</h3>
                  <div className="initiatives-list">
                    {selectedVertical.initiatives.map((item, idx) => {
                      const isString = typeof item === "string";
                      const title = isString ? item.split(":")[0] : item.name;
                      const desc = isString ? item.split(":")[1] : item.desc;
                      return (
                        <div key={idx} className="initiative-item" style={{ borderLeftColor: selectedVertical.accent }}>
                          <h4 className="initiative-name">{title}</h4>
                          {desc && <p className="initiative-desc">{desc.trim()}</p>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}

              {activeTab === "benefits" && (
                <div className="tab-pane fade-in">
                  {selectedVertical.collaborations && (
                    <div className="collaborations-section">
                      <h3 className="section-subheading">Industry & Community Collaborations</h3>
                      <div className="collab-tags-grid">
                        {selectedVertical.collaborations.map((collab, idx) => (
                          <div key={idx} className="collab-card">
                            <span className="collab-icon">🤝</span>
                            <span>{collab}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {selectedVertical.leadershipAndImpact && (
                    <div className="leadership-impact-box" style={{ marginTop: "24px" }}>
                      <h4 className="box-title">Leadership & Skill Development</h4>
                      <p>{selectedVertical.leadershipAndImpact}</p>
                    </div>
                  )}

                  {selectedVertical.futureOutlook && (
                    <div className="future-outlook-box" style={{ marginTop: "20px" }}>
                      <h4 className="box-title">Looking Ahead</h4>
                      <p>{selectedVertical.futureOutlook}</p>
                    </div>
                  )}

                  <h3 className="section-subheading" style={{ marginTop: "28px" }}>Member Benefits</h3>
                  <ul className="benefits-checklist">
                    {selectedVertical.benefits.map((benefit, idx) => (
                      <li key={idx} className="benefit-item">
                        <span className="check-mark" style={{ color: selectedVertical.accent }}>✓</span>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>

            {/* MODAL FOOTER ACTION */}
            <div className="modal-footer-action">
              <button className="modal-cancel-btn" onClick={() => setSelectedVertical(null)}>
                Close
              </button>
              <button
                className="modal-join-btn"
                style={{ background: `linear-gradient(135deg, ${selectedVertical.accent}, #6366f1)` }}
                onClick={handleJoinClick}
              >
                <span>Join {selectedVertical.name} Vertical</span>
                <span className="btn-arrow">→</span>
              </button>
            </div>

          </div>
        </div>
      )}

      <Footer />
    </>
  );
};

export default Verticals;

